import { cookies } from './cookies'

// set user cookie
export const setNoTrackUser = (userType) => {
  cookies.set('no track', userType, { path: '/', maxAge: 60 * 60 * 24 * 60 })
}
// get user cookies
export const getNoTrackUser = () => {
  const noTackUser = cookies.get('no track')
  return !!noTackUser
}

// No track admin cookies

// set Admin cookie
export const setNoTrackAdmin = () => {
  cookies.set('no track admin', 'admin-tracker', {
    path: '/',
    maxAge: 60 * 60 * 24 * 60,
  })
}
// get Admin cookies
export const getNoTrackAdmin = () => {
  const noTackUser = cookies.get('no track admin')
  return !!noTackUser
}
